import { capitalize } from "lodash";
import { GridRenderSlots } from "../../../grid/AgGridManager";
import { DataVariants } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";

export enum Statuses {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  DELETED = "DELETED",
}

export const statusOptions = Object.values(Statuses).map((status) => ({
  value: status,
  label: capitalize(status.toLowerCase()),
}));

export const status: FieldSchema = {
  name: "status",
  // Read, never written. Which workflow state an equipment is in is decided by the resolvers
  // and by manageProposedChanges/processApproveReview, from the operation a request named and
  // the status the record already holds. A form that computes one can only disagree with
  // them, and did: an assigned value of PENDING for every 4EP edit reached `newData` and
  // outlived the review, leaving the equipment pending with nothing left to approve.
  //
  // Still selected, so the grid, the display and the audit trail can read it.
  data: {
    variant: DataVariants.ENUM,
    options: statusOptions,
  },
  dataTransform: {
    fromGraphql: {
      getter: ({ status }) => statusOptions.find((option) => option.value === status)?.value,
    },
    toGraphql: undefined,
    toDb: undefined,
  },
  display: {
    displayed: true,
  },
  form: { label: "Workflow status", disabled: true, displayed: false },
  grid: {
    displayed: true,
    order: 65,
    render: GridRenderSlots.STATUS,
  },
};
